import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useEffect, useState } from 'react';
import { TranslationService } from '../services/TranslationService';
export const TranslationContext = createContext(undefined);
export function TranslationProvider({ children, translations, defaultLanguage = 'pt-BR', }) {
    const [translationService] = useState(() => new TranslationService(translations, defaultLanguage));
    const [currentLanguage, setCurrentLanguage] = useState(defaultLanguage);
    const [, forceUpdate] = useState(0);
    useEffect(() => {
        translationService.loadTranslations(translations);
        forceUpdate(prev => prev + 1);
    }, [translations, translationService]);
    const setLanguage = (language) => {
        translationService.setLanguage(language);
        setCurrentLanguage(language);
    };
    const t = (key, variables) => {
        return translationService.translate(key, variables);
    };
    const availableLanguages = translationService.getAvailableLanguages();
    const contextValue = {
        currentLanguage,
        setLanguage,
        t,
        availableLanguages,
    };
    return _jsx(TranslationContext.Provider, { value: contextValue, children: children });
}
